import * as React from 'react';
import * as styles from '../navigation.module.scss';
import { RadioGroup, Radio, FormControl, FormLabel, FormControlLabel } from '@material-ui/core';
import Navigation from '../../../../../models/navigation';
import useNavigation from '../../../../../hooks/useNavigation';
import { NewNavigation } from '../../../../../hooks/useNavigation';
import AddDashboardNav from './addDashboardNav';
import AddCategory from './addCategory';
import Dashboard from '../../../../../models/dashboard';
import clsx from 'clsx';

interface Props {
  clientId: number;
  navigations: Navigation[];
  setNavigations: (navigations: Navigation[]) => void;
  setSuccessMessage: (message: string) => void;
  setErrorMessage: (message: string) => void;
  loadingDashboards: boolean;
  clientDashboards: Dashboard[];
  scrollRef: React.MutableRefObject<any>;
}

const AddNavigation = ({
  clientId,
  navigations,
  setNavigations,
  setSuccessMessage,
  setErrorMessage,
  loadingDashboards,
  clientDashboards,
  scrollRef
}: Props) => {
  const [inputText, setInputText] = React.useState<string>('');
  const [radioValue, setRadioValue] = React.useState<string>('category');
  const [updating, setUpdating] = React.useState<boolean>(false);
  const { fetchNavigations, addNavigation } = useNavigation();

  const addNavigationHandler = (newNavigation: NewNavigation) => {
    addNavigation(clientId, newNavigation)
      .then(response => {
        setUpdating(true);
        if (response.success) {
          setSuccessMessage(`Navigation ${response.message} created`);
          setInputText('');
          fetchNavigations(clientId)
            .then(fetched => {
              if (fetched) {
                setNavigations(fetched);
                scrollRef.current.scrollToBottom();
              } else {
                setErrorMessage('Navigation fetch failed');
              }
              setUpdating(false);
            })
            .catch(err => {
              setErrorMessage(err.responseJSON.message);
            });
        } else {
          setErrorMessage(response.message);
        }
      })
      .catch(err => {
        setErrorMessage(err.responseJSON.message);
      });
  };

  const radioChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioValue((event.target as HTMLInputElement).value);
  };

  return (
    <div className={styles.addNavigation}>
      <FormControl size="small">
        <FormLabel component="legend" className={styles.radioGroupLabel}>
          Add Dashboard Type
        </FormLabel>
        <RadioGroup name="add-type" value={radioValue} onChange={radioChangeHandler} className={styles.radioGroup}>
          <FormControlLabel
            value="category"
            control={<Radio color="primary" />}
            label="Dashboard Category"
            className={styles.radioLabel}
          />
          <FormControlLabel
            value="dashboard"
            control={<Radio color="primary" />}
            label="Dashboard"
            className={clsx(styles.radioLabel, navigations.length === 0 && styles.radioDisabled)}
            disabled={navigations.length === 0}
          />
        </RadioGroup>
      </FormControl>
      {radioValue === 'category' ? (
        <AddCategory
          inputText={inputText}
          setInputText={setInputText}
          updating={updating}
          navigations={navigations}
          addNavigationHandler={addNavigationHandler}
        />
      ) : (
        <AddDashboardNav
          clientId={clientId}
          navigations={navigations}
          updating={updating}
          addNavigationHandler={addNavigationHandler}
          setErrorMessage={setErrorMessage}
          setSuccessMessage={setSuccessMessage}
          loadingDashboards={loadingDashboards}
          clientDashboards={clientDashboards}
        />
      )}
    </div>
  );
};

export default AddNavigation;
